import { getField, updateField } from 'vuex-map-fields'
import MultipleLine from './multipleLine'
import generateBaseImportFromStage from '@/store/baseImportFromStage'

export const namespaced = true

let baseUrl = '/multiple_phreatic_lines/'

const multipleLine = new MultipleLine(baseUrl)
const baseImportFromStage = generateBaseImportFromStage({})

const getDefaultState = () => {
  return {
    ...structuredClone(multipleLine.state),
    ...structuredClone(baseImportFromStage.state)
  }
}

export const state = getDefaultState()

export const mutations = {
  ...multipleLine.mutations,
  ...baseImportFromStage.mutations,
  updateField
}

export const actions = {
  ...baseImportFromStage.actions,
  ...multipleLine.actions,
  async importPhreaticLineFromStage(
    { commit, dispatch },
    { sourceSchematisationStageId, targetSchematisationStageId }
  ) {
    try {
      commit('TOGGLE_IMPORT_FROM_STAGE_LOADING')
      const {
        imported_multiple_phreatic_line,
        imported_phreatic_line,
        imported_phreatic_reference_line
      } = await dispatch('importFromStage', {
        import_option: {
          source_stab_schematisation_stage_id: sourceSchematisationStageId,
          target_stab_schematisation_stage_id: targetSchematisationStageId
        },
        stab_schematisation_stage: targetSchematisationStageId
      })
      commit('SET_ITEMS', [imported_multiple_phreatic_line])
      commit('SET_CURRENT_ITEM', imported_multiple_phreatic_line)
      commit('phreaticLine/REPLACE_LINE', imported_phreatic_line, { root: true })
      commit('phreaticLine/SET_COORDINATE', null, { root: true })
      commit('phreaticReferenceLine/REPLACE_LINE', imported_phreatic_reference_line, { root: true })
      commit('phreaticReferenceLine/SET_COORDINATE', null, { root: true })
    } catch (e) {
      console.log(e)
    } finally {
      commit('TOGGLE_IMPORT_FROM_STAGE_LOADING')
    }
  }
}
export const getters = {
  ...multipleLine.getters,
  getDepthDryTornZone: (state) => {
    return state.currentItem ? state.currentItem.depth_dry_torn_zone : null
  },
  getItemByStabSchematisationStage:
    (state) =>
    (stabSchematisationStage = null) => {
      if (stabSchematisationStage) {
        return state.multipleLineOverview.find(
          (item) => item.stab_schematisation_stage === stabSchematisationStage.id
        )
      }
    },
  getField,
  getBulging: (state) => {
    return state.currentItem ? state.currentItem.bulging : null
  }
}
